import config from '@/shared/config/config';
import { RpmWorkflowTab } from '@/shared/lib/types/remotePatientMonitoring';

export const months: string[] = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const mandatoryTabsForEnrolment: string[] = [
  RpmWorkflowTab.CLINICAL_SUMMARY,
  RpmWorkflowTab.DEVICES,
  RpmWorkflowTab.CONSENT_MANAGEMENT,
  RpmWorkflowTab.MEDICAL_RECONCILIATION,
  RpmWorkflowTab.MEDICAL_CONSULTS,
  RpmWorkflowTab.CARE_PLAN,
  RpmWorkflowTab.CONFIGURATION
];

export const mandatoryTabsForRpmFollowup: RpmWorkflowTab[] = [
  RpmWorkflowTab.CONSENT_MANAGEMENT,
  RpmWorkflowTab.CLINICAL_SUMMARY,
  RpmWorkflowTab.MEDICAL_RECONCILIATION,
  RpmWorkflowTab.MEDICAL_CONSULTS,
  RpmWorkflowTab.CARE_PLAN
];

// How far ahead of now a care activity's Reviewed Datetime may be.
export const MAX_CARE_ACTIVITY_FUTURE_DAYS = 3;

export const maxNamesToShow = 2;

/**
 * Height of the top navbar, in pixels.
 */
export const NAVBAR_HEIGHT = 75;

// New pharmacy chart-access URL (ticket 86exhd4yd). Replaces the old per-patient fleet
// path '/p/${company}/rpm'. ${company} is the pharmacy handle (org_handle, or uuid fallback).
export const patientTemporaryAccessUrlPaths = `/${config.CHARTS_URL_PREFIX}/\${company}`;

export const timezoneNameMap: Record<string, string> = {
  'America/New_York': 'ET',
  'America/Detroit': 'ET',
  'America/Indiana/Indianapolis': 'ET',
  'America/Chicago': 'CT',
  'America/Mexico_City': 'CST',
  'America/Asuncion': 'PYT',
  'Asia/Kolkata': 'IST',
  'Asia/Calcutta': 'IST'
};

export const utcOffsetMap: Record<number, string> = {
  '-300': 'ET',
  '-240': 'ET',
  '-360': 'CT',
  '330': 'IST'
};

// US zones named without the season (EST and EDT are both ET), so a label is right all year.
export const usTimezoneAbbreviationMap: Record<string, string> = {
  EST: 'ET',
  EDT: 'ET',
  CST: 'CT',
  CDT: 'CT',
  MST: 'MT',
  MDT: 'MT',
  PST: 'PT',
  PDT: 'PT',
  AKST: 'AKT',
  AKDT: 'AKT',
  HST: 'HT',
  HDT: 'HT'
};

export const TAG_STARRED = 'Starred';

export const TAG_CARELINK_PRIORITY = 'Carelink Priority';

export const MEDICAID = 'Medicaid';

// Patient-level scope for the docked SOAP panel. Match against `useLocation().pathname` — the
// helpers in `util/location.ts` read `window.location` and do not re-evaluate on navigation.
export const PATIENT_DETAILS_PATH_RE = /^\/patients\/([^/]+)\/details(\/|$)/;

export const getPatientIdFromPath = (pathname: string): string | null => pathname.match(PATIENT_DETAILS_PATH_RE)?.[1] ?? null;
